/**
 * Checkbox label filter helper
 *
 * Adds a small search input above a given container and live-filters its option
 * rows by the text content of their labels.
 *
 * Usage:
 *   window.attachCheckboxLabelFilter(container, {
 *     placeholder: 'Search…',                   // optional; placeholder text
 *     inputId: 'checkbox-label-filter-input',   // optional; unique ID for the input
 *     rowSelector: ':scope > *',                // optional; selector for option rows
 *     infoLabelText: 'Select from options below'// optional; helper text (omit if falsy)
 *   });
 *
 * Parameters:
 * - container: Element or CSS selector for the container holding option rows.
 * - options:   Optional config. If `rowSelector` matches no nodes, the script
 *              falls back to all <label> elements inside the container.
 *
 * Behavior:
 * - Inserts the search input (and optional helper label) before the container.
 * - On input, compares the lowercased query against each row's label text and
 *   hides/shows rows accordingly.
 * - If a node is a <label>, the nearest wrapper (li, div, .field, .row) is
 *   toggled so the entire row is shown/hidden.
 */

function attachCheckboxLabelFilter(container, options) {
    options = options || {};
    let el = typeof container === 'string' ? document.querySelector(container) : container;
    if (!el || !el.parentNode) {
        console.warn('attachCheckboxLabelFilter: container not found');
        return;
    }

    if (el.dataset.checkboxLabelFilterAttached === '1') return;
    el.dataset.checkboxLabelFilterAttached = '1';

    const placeholder = options.placeholder || 'Search…';
    let inputId = options.inputId || 'checkbox-label-filter-input';
    let infoLabelText = options.infoLabelText || 'Select from options below';
    let rowSelector = options.rowSelector || ':scope > *';

    // Create search input
    let input = document.createElement('input');
    input.type = 'search';
    input.id = inputId;
    input.placeholder = placeholder;
    input.autocomplete = 'off';
    input.style.marginBottom = '8px';
    input.style.width = '100%';
    input.style.boxSizing = 'border-box';
    el.parentNode.insertBefore(input, el);

    // Info label
    if (infoLabelText) {
        let infoLabel = document.createElement('label');
        infoLabel.textContent = infoLabelText;
        infoLabel.style.display = 'block';
        infoLabel.style.margin = '4px 0 8px';
        el.parentNode.insertBefore(infoLabel, el);
    }

    // Rows: try configured selector; fallback to labels
    let rows = Array.from(el.querySelectorAll(rowSelector));
    if (!rows.length) rows = Array.from(el.querySelectorAll('label'));

    function rowEl(n) {
        if (n.tagName && n.tagName.toLowerCase() === 'label') {
            return n.closest('li, div, .field, .row') || n;
        }
        return n;
    }

    function labelText(node) {
        let lab = node.querySelector && node.querySelector('label');
        let text = lab ? lab.textContent : node.textContent || '';
        return text.trim().toLowerCase();
    }

    input.addEventListener('input', function () {
        let q = input.value.trim().toLowerCase();
        rows.forEach(function (n) {
            let r = rowEl(n);
            r.style.display = !q || labelText(r).includes(q) ? '' : 'none';
        });
    });
}

// Expose globally so templates or other scripts can call it
window.attachCheckboxLabelFilter = attachCheckboxLabelFilter;


